import React from 'react'; 
import { createRoot } from 'react-dom/client'; 
import { BrowserRouter } from 'react-router-dom'; 
import App from './App'; 
import './styles/global.css'; 
import './utils/apiClient'; 


const root = createRoot(document.getElementById('root')); 
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <App/>
  </BrowserRouter>
); 
